const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBProgressDelivered(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconB-progress-delivered",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "iconB-progress-delivered1",
    serifid: "iconB-progress-delivered"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,1c6.071,0 11,4.929 11,11c0,6.071 -4.929,11 -11,11c-6.071,0 -11,-4.929 -11,-11c0,-6.071 4.929,-11 11,-11Zm0,1.986c-4.975,0 -9.014,4.039 -9.014,9.014c0,4.975 4.039,9.014 9.014,9.014c4.975,-0 9.014,-4.039 9.014,-9.014c-0,-4.975 -4.039,-9.014 -9.014,-9.014Zm5.356,5.805c0.166,0.174 0.269,0.41 0.269,0.671c0,0.276 -0.115,0.525 -0.3,0.702l-6.206,5.923c-0.174,0.166 -0.41,0.269 -0.67,0.269c-0.26,-0 -0.497,-0.103 -0.671,-0.269l-3.102,-2.961c-0.186,-0.178 -0.301,-0.427 -0.301,-0.703c0,-0.536 0.435,-0.971 0.971,-0.971c0.26,-0 0.497,0.102 0.671,0.269l2.432,2.321l5.534,-5.283c0.174,-0.166 0.411,-0.269 0.671,-0.269c0.275,0 0.523,0.115 0.7,0.299c0.001,0 0.002,0.001 0.002,0.002Z",
    style: {
      fill: "#01b800"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBProgressDelivered);
export default __webpack_public_path__ + "static/media/iconB-progress-delivered.18c521b4a67d7f76a6bb1007efc9e32e.svg";
export { ForwardRef as ReactComponent };